var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QSelect',_vm._b({attrs:{"value":_vm.value,"options":_vm.options,"display-value":_vm.value ? _vm.value : 'Select'},on:{"input":function($event){return _vm.$emit('input', $event)}}},'QSelect',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }